module.exports = __webpack_public_path__ + "img/footerPolice.be3518e9.png";